import React from 'react';
import styles from './Title.module.css';

const Title = ({ content }) => <h2 className={styles.h2}>{content}</h2>;

export default Title;
